import { Link } from "react-router-dom";
import logo from "../assets/img/logo/Logo Outlined.png";

export const NavLinks = [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "About",
    url: "/about",
  },
  {
    name: "Tracking",
    url: "/Tracking",
  },
  {
    name: "Services",
    url: "/services",
  },
  {
    name: "Contact",
    url: "/contact",
  },
];

export default function Navbar() {
  return (
    <header class="header header-before-off">
      <div class="main-wrapper">
        <div class="navbar navbar-expand-lg bsnav bsnav-sticky bsnav-sticky-slide bsnav-transparent pt-2 pb-2">
          <div class="navbar-container">
            <div class="navbar-extra-logo">
              <Link to="/" className="navbar-brand g-nop">
                <img
                  src={logo}
                  className="logo-scrolled"
                  style={{ width: "130px", height: "70px" }}
                  alt="thumb"
                />
              </Link>
            </div>

            <div class="top-header-menu">
              {/* <div class="top-bar-area pos-rel topbar-white">
							<img src={topBar} alt="no image" className="top-bar-shape" />
							<div class="row">
								<div class="col-xl-10 col-lg-6">
									<div class="top-box-wrp d-flex justify-content-md-center align-items-center">
										<div class="top-box top-location mr-30">
											<i class="fa-solid fa-location-dot"></i>
											<span>121 Wallstreet Street, NY York, USA</span>
										</div>
										<div class="top-email top-box mr-30">
											<i class="fa-solid fa-envelope"></i>
											<span>support@email.com</span>
										</div>
										<div class="top-phone top-box">
											<i class="fa-solid fa-phone"></i>
											<span> + 124 569 89 09</span>
										</div>
									</div>
								</div>
								<div class="col-xl-2 col-lg-6">
									<div class="top-bar-social">
										<ul class="top-social">
											<li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
											<li><a href="#"><i class="fab fa-instagram"></i></a></li>
											<li><a href="#"><i class="fab fa-twitter"></i></a></li>
											<li><a href="#"><i class="fab fa-youtube"></i></a></li>
										</ul>
									</div>
								</div>
							</div>
						</div> */}
              <div class="navbar-menu-opt">
                <div class="navbar-brand-tog">
                  <Link to="/" className="navbar-brand g-nop">
                    <img
                      src={logo}
                      className="logo-scrolled"
                      style={{ width: "130px", height: "70px" }}
                      alt="thumb"
                    />
                  </Link>
                  <button class="navbar-toggler toggler-spring">
                    <span class="navbar-toggler-icon"></span>
                  </button>
                </div>
                <div class="collapse navbar-collapse justify-content-md-between">
                  <Link to="/" className="navbar-brand nop">
                    <img
                      src={logo}
                      className="logo-scrolled"
                      style={{ width: "130px", height: "70px" }}
                      alt="thumb"
                    />
                  </Link>
                  <ul className="navbar-nav navbar-mobile justify-content-md-center w-100">
                    {NavLinks.map((link, index) => (
                      <li key={index} className="nav-item dropdown fadeup">
                        <Link to={link.url} className="nav-link">
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <div class="search-cart nav-profile">
                    <Link to="/tracking" className="btn-1 btn-md">
                      Track Cargo
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bsnav-mobile">
          <div class="bsnav-mobile-overlay"></div>
          <div class="navbar"></div>
        </div>
      </div>
    </header>
  );
}
